import { message } from "antd";

export const safeJsonParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

export const parseError = (error, showError) => {
  const errorMessage =
    error?.errorMessage ||
    error?.response?.data?.errorMessage ||
    error?.message ||
    "something went wrong try again";

  if (showError) message.error(errorMessage);
  return {
    message: errorMessage,
    code: error?.statusCode || error?.errorCode || error?.code || 500,
    error: error,
  };
};

export const getInitials = (user) => {
  return `${user?.first_name?.charAt(0) || ""}${
    user?.last_name?.charAt(0) || ""
  }`.toUpperCase();
};

export const getFullName = (user) =>
  [user?.first_name, user?.last_name].filter(Boolean).join(" ");

export const getPhoneNumber = (c) =>
  `${c?.mobile_number || `${c?.phone ? `${c?.phone_country_code}-${c?.phone}` : ""}` || ""}`.trim();

export const getTimezoneLabel = (timezone) => {
  if (timezone?.includes("New_York")) return "GMT";
  if (timezone?.includes("Mumbai") || timezone?.includes("Kolkata"))
    return "IST";
  return "GMT";
};

export const formatWorkingHours = (workingHours) => {
  if (!workingHours) return "24 Hours";

  // Get first enabled day's hours
  const days = Object.keys(workingHours);
  for (let day of days) {
    if (workingHours[day].enabled && workingHours[day].slots?.length > 0) {
      const slot = workingHours[day].slots[0];
      return `${slot.start} - ${slot.end}`;
    }
  }
  return "24 Hours";
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
};

export const findLast = (array, key, value) => {
  for (let i = array.length - 1; i >= 0; i--) {
    if (array[i][key] === value) {
      return array[i];
    }
  }
  return null;
};

export const WORKBOOK_ROLES = {
  OWNER: "owner",
  EDITOR: "editor",
  VIEWER: "viewer",
};

export const PLAN_TYPES = {
  PER_MEMBER: "per_member",
  ENTERPRISE: "enterprise",
  PROFESSIONAL: "professional",
  STARTER: "starter",
};
